import Hashids from 'hashids';

export const hashIdCoderInitiator = codeLength => new Hashids(
  'I am a pizza. With extra cheese.',
  codeLength,
  'abcdefghijklmnopqrstuvwxyz0123456789'
);

export default hashIdCoderInitiator( 6 )
